import * as React from "react";
import BackgroundHeader from '../../assets/icons/BG1.jpg'
import Menu from "./menu";
const Header = () => {
  return (
    <div
    style={{backgroundImage:`url(${BackgroundHeader})` , backgroundSize:'100% 100%' , backgroundRepeat:'no-repeat' , backgroundPosition:"left top" }}
    className="  relative font-IRANSansWeb caret-transparent h-[640px] screen1300:h-[500px] screen1000:h-[430px] screen700:h-[330px] screen500:h-[250px] screen400:h-[220px]">
      <Menu />
    </div>
  );
};

export default Header;
